import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { getUsers, createUser, updateUser, deleteUser } from "../api/users"

export const useFetchUsers = (offset, limit, search) => {
  return useQuery({
    queryKey: ["users", offset, limit, search],
    queryFn: () => getUsers({ offset, limit, search }),
    select: (response) => ({
      users: response.data.data.users,
      pagination: {
        total: response.data.data.total,
        totalPages: Math.ceil(response.data.data.total / limit),
      },
    }),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  })
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => createUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ userId, data }) => updateUser(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (userId) => deleteUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })
}
